import React, { Component } from "react";
import { FormattedMessage, injectIntl } from 'react-intl'

import downloadQrcode from "./res/phonedownload/download_qrcode.png"
import upgradeVip from "./res/phonedownload/upgrade_vip.png"
import Locale from './lang/Locale'

import { message } from 'antd';

import "./PhoneDownload.css";
import "antd/dist/antd.min.css";
import "url-search-params-polyfill"


const androidAddress = 'https://play.google.com/store/apps/details?id=com.xdiarys.www'
const androidChsAddress = 'https://download.xdiarys.com/android/dkcalendar-release.apk'
const homepage = 'https://www.xdiarys.com/?src=windows';

const errorMessage = ( msg ) => {
    message.error( msg );
};

const successMessage = ( msg ) => {
    message.success( msg, 10 );
};

class PhoneDownload extends Component {

    constructor(props) {

        super(props);

        
        const { intl } = this.props;

        this.state = {
            vipdisplay:'none',
            othersysText:intl.formatMessage({ id: 'phodedownload_macos' }),
            systemimage: require("./res/phonedownload/appstore.png"),
            ioslink:'',
            otherlink:'',
            taskKey:''
        };

        this.onclickDownloadiOS = this.onclickDownloadiOS.bind(this);

    }

    componentWillMount() {
        const { intl } = this.props;

        var search = new URLSearchParams(window.location.search);
        let paramOS = search.get("os");
        let taskKey = search.get("task_key");

        let lang = Locale.Instance.getLang();
        

        let country = 'us';
        if( lang === 'chs' ) {
            country = 'cn';
        } else if( lang === 'cht' ) {
            country = 'tw';
        } else if( lang === 'kor' ) {
            country = 'kr';
        }

        let macOSUrl = `https://apps.apple.com/${country}/app/CalendarTask/id1570563588`;
        let iOSUrl = `https://apps.apple.com/${country}/app/CalendarTask/id1570563588?platform=iphone`;


        
        document.title = Locale.Instance.getMessagebyId('homepage_title');

        this.setState( { ioslink:iOSUrl, otherlink:macOSUrl });

        this.setState( { taskKey:taskKey });

        
        if( paramOS === 'macos') {
            let text = intl.formatMessage({ id: 'phodedownload_windows' });
            let image = require("./res/phonedownload/windows.png");
            let link = homepage;
            this.setState( {othersysText:text, systemimage:image, otherlink:link});
        }

        let paramVip = search.get("vip");
        if( paramVip === '1' ) {
            this.setState( {vipdisplay:'block'});
        }

        console.log(taskKey)
        if (taskKey != null && taskKey.length > 0) {
            this.AcceptTask(taskKey);
        }
    }

    async AcceptTask(taskKey) {
        
        let retobj = await fetch( 'https://api-account.xdiarys.com/api/users/task/accept/' + taskKey, {
            method: "GET",
            credentials: 'include',
            headers: {
            'Accept': 'application/json, text/plain, */*',
            }
        })
        .then(function (response) {
            return  response.json();
        })
        .then((myJson) => {
            return myJson;
        })
        .catch(function (e) {
            console.log( e );
        });

        
        console.log( retobj );
        if( retobj.result === 1 ) {
            successMessage(Locale.Instance.getMessagebyId('vip_task_succ'));
        } else{
            errorMessage(Locale.Instance.getMessagebyId('vip_task_error'));
        }
    }
    
    componentDidMount() {
       
        this.onclickDownloadAndrod = this.onclickDownloadAndrod.bind(this);
    }

    onclickDownloadAndrod(){
        let lang = Locale.Instance.getLang();
        if( lang === 'chs' ) {
            window.location.href = androidChsAddress;
        } else {
            window.location.href = androidAddress;
        }
    }

    onclickDownloadiOS(){
        window.location.href = this.state.ioslink;
    }

    render() {

        let image_1 = require("./res/phonedownload/chs_1.png")
        let image_2 = require("./res/phonedownload/chs_2.png")
        let image_3 = require("./res/phonedownload/chs_3.png")
        let image_4 = require("./res/phonedownload/chs_4.png")
        
        
        let locale = Locale.Instance.getLocal();
        if (locale === 'ko') {
            image_1 = require("./res/phonedownload/kor_1.jpg")
            image_2 = require("./res/phonedownload/kor_2.jpg")
            image_3 = require("./res/phonedownload/kor_3.jpg")
            image_4 = require("./res/phonedownload/kor_4.jpg")
        }
        else if(locale === 'zh-tw' ) {
            image_1 = require("./res/phonedownload/cht_1.jpg")
            image_2 = require("./res/phonedownload/cht_2.jpg")
            image_3 = require("./res/phonedownload/cht_3.jpg")
            image_4 = require("./res/phonedownload/cht_4.jpg")
        }
        else if(locale === 'en' ) {
            image_1 = require("./res/phonedownload/usa_1.jpg")
            image_2 = require("./res/phonedownload/usa_2.jpg")
            image_3 = require("./res/phonedownload/usa_3.jpg")
            image_4 = require("./res/phonedownload/usa_4.jpg")
        }
        

        return (

            <div className="pdcontainer" >
                <div className="containertitle">
                    <div className="titlebar" >
                        <img src={downloadQrcode} alt="download Qrcode" className="downloadqrcode" />
                        <div className="titlecontainer" >
                            <div className="dltitle"><FormattedMessage id='phonedownload_title' /></div>
                            <div className="dlslogn"><FormattedMessage id='phonedownload_slogan' /></div>
                            <div className="dlbcontainer">
                                <div alt="download ios" className="doloadbtnios" onClick={this.onclickDownloadiOS} />
                                <div alt="download android" className="doloadbtnandroid" onClick={this.onclickDownloadAndrod} />
                            </div>
                        </div>
                    </div>
                </div>

                <div className="containerupgradevip" style={{display:this.state.vipdisplay}}  >
                    <img src={upgradeVip} alt="download android" />
                    <div className="upgradeviptext">
                        <FormattedMessage id='phonedownload_send_vip' />
                    </div>
                </div>
    

                <div className="container2">
                    <div className="screentext"></div>
                    <div className="imagescontainer">
                        <img src={image_1} alt="download view1" className="imagelist" />
                        <img src={image_2} alt="download view2" className="imagelist" />
                        <img src={image_3} alt="download view3" className="imagelist" />
                        <img src={image_4} alt="download view4" className="imagelist" />
                    </div>
                    <div className="screentext"></div>
                </div>

                <div className="othercontainer">
                    <div className="otherimagecontainer" >
                        <img src={this.state.systemimage} alt="download system" className="imagesystem" />
                    </div>
                    <div className="othertext">
                        {this.state.othersysText}
                    </div>
                    <div className="otherbuttoncontainer">
                        <a className="otherbutton" href={this.state.otherlink}>
                            <FormattedMessage id='phodedownload_otherbutton' />
                        </a>
                     </div>
                </div>

                <div className="bottomcontainer">
                    <div className="aboutcontainer">
                        <div className="abouttext">
                            <FormattedMessage id='phodedownload_about' />&nbsp;&nbsp;service@xiaoweiyunfu.com
                        </div>
                    </div>
                    <div className="copyrighttext">
                        Copyright © Beijing Xiaowei Cloud Service Technology Co., Ltd.&nbsp;&nbsp;&nbsp;&nbsp;<FormattedMessage id='phodedownload_copyright' />
                    </div>
                </div>
            </div>
        )
    }
}



export default injectIntl(PhoneDownload);